import { useEffect, useState } from 'react';
import { findEntityData } from '../../api/apiService';
import Icon from "../../assets/a3.webp";

export default function WhatWeDo() {
    const [section1, setSection1] = useState()
    const findData = async () => {
        const res = await findEntityData('sss_about_what_we_do')
        setSection1(res?.data?.[0])
    }

    useEffect(() => {
        findData()
    }, [])
    return (
        <section className="max-w-5xl mx-auto my-12">
            <div className="mb-10 text-left">
                <h1
                    className="text-2xl md:text-3xl font-bold text-[#F37934] tracking-wide font-cinzel mb-4"
                    data-aos="zoom-in"
                    data-aos-duration="800"
                    data-aos-easing="ease-out"
                >
                    {section1?.heading}
                </h1>
                <p className="max-w-2xl text-sm md:text-base text-[#56453F]">
                    {section1?.content}
                </p>
            </div>

            <div className="mb-14">
                <h2 className="text-xl font-bold font-cinzel text-[#56453F] mb-2">
                    {section1?.heading2}
                </h2>
                <p className="pb-8 text-sm md:text-base text-[#56453F]">
                    {section1?.content2}
                </p>

                <div className="space-y-6">
                    {section1?.data?.map((service, index) => (
                        <article
                            key={index}
                            className="rounded-2xl p-6 flex items-center md:items-start space-x-4 border-2 border-white bg-gradient-to-br from-[#F0F0E5] via-white to-[#F0F0E5] shadow-sm"
                            data-aos="zoom-in-up"
                            data-aos-duration="800"
                            data-aos-delay={200 * (index + 1)}
                        >
                            <div
                                className="p-3 flex items-center justify-center flex-shrink-0"
                                data-aos="flip-left"
                                data-aos-duration="800"
                            >
                                <img
                                    src={Icon}
                                    alt='success shipping services'
                                    className="w-12 h-12 md:w-14 md:h-14"
                                />
                            </div>

                            <div className="text-left">
                                <h3 className="text-[#56453F] font-quicksand font-bold mb-2 text-base md:text-lg">
                                    {service.heading}
                                </h3>
                                <p className="text-sm md:text-base text-[#56453F] max-w-xl">
                                    {service.content}
                                </p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
